"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Collapsible = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _tokens = _interopRequireDefault(require("@paprika/tokens"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var Collapsible = _styledComponents["default"].div.withConfig({
  displayName: "Collapsiblestyles__Collapsible",
  componentId: "sc-1m0v0pb-0"
})(["&,*{box-sizing:border-box;}", " color:", ";display:block;line-height:", ";width:100%;.collapsible__label{display:inline-block;border-radius:", ";margin-left:-", ";margin-right:-", ";padding-left:", ";padding-right:", ";width:calc(100% + ", ");}.collapsible__icon--left{margin-right:", ";}.collapsible__icon--right{float:right;margin-left:", ";}.collapsible__label--is-toggle-icon-only{margin:0;width:auto;}.collapsible__label--left{margin-right:", ";}.collapsible__label--right{float:right;margin-left:", ";}.collapsible__icon svg{color:", ";vertical-align:-2px;}.collapsible__body{width:100%;}"], _stylers["default"].fontSize(), _tokens["default"].color.black, _stylers["default"].spacer(3), _tokens["default"].border.radius, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].space, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].spaceSm, _tokens["default"].textColor.icon);

exports.Collapsible = Collapsible;
//# sourceMappingURL=Collapsible.styles.js.map